export const questionType = [
  { name: '单选题', id: 1 },
  { name: '多选题', id: 2 },
  { name: '判断题', id: 3 },
  { name: '排序题', id: 4 },
  { name: '填空题', id: 5 }
];
export const questionLevel = [
  { name: '容易', id: 0 },
  { name: '中等', id: 1 },
  { name: '困难', id: 2 }
];
export const vedioType = [
  { name: '理论知识', id: 0 },
  { name: '读片知识', id: 1 }
];
export const checkType = [
  { name: 'CT', id: 'CT' },
  { name: 'MR', id: 'MR' },
  { name: 'CR', id: 'CR' },
  { name: 'DR', id: 'DR' }
];
export const baseMenu = [
  { name: '试题库', id: 1 },
  { name: '视频库', id: 2 },
  { name: '课件库', id: 3 },
  { name: '病例库', id: 4 },
];
export const genderData = [
  { name: '男', id: '男' },
  { name: '女', id: '女' }
//   { name: '其他', id: 'O' },
//   { name: '未知', id: 'U' }
]
export const classNamePrefix = [
  { value: '2021届', label: '2021届' },
  { value: '2022届', label: '2022届' },
  { value: '2023届', label: '2023届' },
  { value: '2024届', label: '2024届' },
  { value: '2025届', label: '2025届' },
  { value: '2026届', label: '2026届' }
]
export const searchKeys = [
  { name: '标题', id: 1,},
  { name: '关键字', id: 2},
  { name: '作者', id: 3},
  { name: 'ICD国际疾病编码', id: 4},
  { name: '题目编号', id: 5}
]
export const examScoreArr = [
  { name: '100分制', id: 100},
  { name: '120分制', id: 120},
  { name: '150分制', id: 150}
]
export const checkTypeList = [
  { label: 'CT', value: '1' },
  { label: 'MR', value: '2' },
  { label: 'CR', value: '4' },
  { label: 'DR', value: '8' },
  { label: 'DSA', value: '16' },
  { label: 'PET', value: '32' },
  { label: 'US', value: '64' },
  { label: 'ECG', value: '128' }
]
export const applicableGroups = [
  { label: '见习生', value: '1' },
  { label: '实习生', value: '2' },
  { label: '住培生一年级', value: '4' },
  { label: '住培生二年级', value: '8' },
  { label: '住培生三年级', value: '16' },
  { label: '主治医生', value: '32' },
  { label: '副主任医师及以上', value: '64' }
]


// WEBPACK FOOTER //
// ./src/data/data.js